module.exports = __webpack_public_path__ + "media/site_templates/www.localbathroomrenovations.net.au/images/feature_3-8694980213053ff6e7e46efc833a4085.jpeg";